import React, { ReactNode } from 'react';

type Props = {
  children: ReactNode;
  className?: string;
};

const SliderProductSlide = ({ children, className }: Props) => (
  <div className={className} aria-roledescription="slide" data-testid="subscription-product-card">
    {children}
  </div>
);

export default SliderProductSlide;
